import { useContext } from "react"
import { ImportacaoClientesContext } from "./ImportacaoClientesContext"

export function useImportacaoClientesContext() {
    return useContext(ImportacaoClientesContext)
}
